import { type FunctionComponent } from "react";
import { makeRipple } from "@/react/core/ripple-utils.ts";
import { onCompleteOrder } from "@/react/DeliveryManagementView/DeliveryManagementLogic.tsx";
import { LL0 } from "@/react/core/I18nService.tsx";

interface CompleteOrderProps {
  onClose?: () => void
}

const CompleteOrder: FunctionComponent<CompleteOrderProps> = ({ onClose }) => {
  return (
    <div className="w-[355px] bg-white flex flex-col justify-center pt-8 px-6 pb-6 gap-3 font-mulish">
      <div className="text-center font-bold text-[18px] text-[#0051c1]">{LL0().onlineOrder.completeOrder()}</div>
      <div className="text-center text-[16px] text-[#1e1e23]">
        {LL0().deliveryManagement.completeOrderPopup()}
      </div>
      <div className="flex gap-1 font-bold text-[14px]">
        <div
          className="w-[150px] h-8 flex items-center justify-center border border-[#1271ff] text-[#1271ff] rounded"
          ref={makeRipple}
          onClick={onClose}
        >
          {LL0().onlineOrder.cancel()}
        </div>
        <div
          className="w-[150px] h-8 flex items-center justify-center bg-[#1271ff] text-white rounded"
          onClick={() => {
            onCompleteOrder()
            onClose?.()
          }}
          ref={makeRipple}
        >
          {LL0().ui.ok()}
        </div>
      </div>
    </div>
  )
}

export default CompleteOrder;